export interface PricingTier {
  id: number;
  name: string;
  price: string;
  period: string;
  minutes: number;
  features: string[];
  landingPageFeatures?: string[]; // Alternative features for landing page
  popular: boolean;
  overageRate?: string;
  buttonText?: string;
}

export const pricingTiers: PricingTier[] = [
  {
    id: 1,
    name: 'Starter',
    price: '$0',
    period: 'forever',
    minutes: 15,
    features: [
      '15 minutes of LIVE interview per month',
      'No additional minutes',
      'Random easy questions only',
    ],
    popular: false,
    buttonText: 'Get Started',
  },
  {
    id: 2,
    name: 'Practice',
    price: '$12.99',
    period: '/month',
    minutes: 60,
    features: [
      '60 minutes of LIVE interview per month',
      '$0.24 every additional minute',
      'Customizable questions',
      'Technical support',
    ],
    popular: false,
    overageRate: '$0.24',
    buttonText: 'Get Started',
  },
  {
    id: 3,
    name: 'Pro',
    price: '$29.99',
    period: '/month',
    minutes: 150,
    features: [
      '150 minutes of LIVE interview per month',
      '$0.22 every additional minute',
      'Customizable questions',
      'Prioritized technical support',
    ],
    popular: true,
    overageRate: '$0.22',
    buttonText: 'Start Pro',
  },
  {
    id: 4,
    name: 'Onsite',
    price: '$64.99',
    period: '/month',
    minutes: 350,
    features: [
      '350 minutes of LIVE interview per month',
      '$0.20 every additional minute',
      'Customizable questions',
      'Prioritized technical support',
    ],
    popular: false,
    overageRate: '$0.20',
    buttonText: 'Go Premium',
  },
];

// Helper function to get display name for different contexts
export const getTierDisplayName = (
  tier: PricingTier,
  context: 'full' | 'short' = 'short'
): string => {
  if (context === 'full' && tier.name === 'Starter') {
    return 'Starter (Free)';
  }
  return tier.name;
};

// Helper function to get features for different contexts
export const getTierFeatures = (tier: PricingTier): string[] => {
  return tier.features;
};

// Helper function to get button text
export const getButtonText = (
  tier: PricingTier,
  context: 'landing' | 'pricing' = 'pricing',
  userLoggedIn = false
): string => {
  if (context === 'pricing') {
    if (tier.name === 'Starter') {
      return 'Get Started';
    }
    return 'Choose Plan';
  }

  // Landing page context
  if (tier.name === 'Starter') {
    return 'Start Free';
  }
  return tier.buttonText || 'Get Started';
};
